import { Dialog, Typography, CircularProgress } from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import {
  StyledDialogTitle,
  StyledDialogContent,
  StyledDialogActions,
  CancelButton,
  DangerButton,
} from "../../shared/components";

interface ClearConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  locationName: string;
  isLoading?: boolean;
}

export const ClearConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  locationName,
  isLoading = false,
}: ClearConfirmationModalProps) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown={isLoading}
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "500px",
          width: "90vw",
          borderRadius: "12px",
        },
      }}
    >
      <StyledDialogTitle colorScheme="error">
        <Typography variant="h5" component="div">
          <WarningIcon fontSize="large" />
          Confirm Clear Location
        </Typography>
      </StyledDialogTitle>

      <StyledDialogContent>
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: "bold",
            color: (theme) => theme.palette.error.main,
            marginBottom: (theme) => theme.spacing(1),
          }}
        >
          {locationName}
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            lineHeight: 1.5,
            color: (theme) => theme.palette.text.primary,
            marginBottom: (theme) => theme.spacing(2),
          }}
        >
          Are you sure you want to clear all billets from this location?
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            lineHeight: 1.5,
            color: (theme) => theme.palette.error.main,
            fontWeight: "bold",
            marginBottom: (theme) => theme.spacing(2),
          }}
        >
          This action cannot be undone.
        </Typography>
      </StyledDialogContent>

      <StyledDialogActions>
        <CancelButton onClick={handleClose} disabled={isLoading}>
          Cancel
        </CancelButton>

        <DangerButton onClick={handleConfirm} disabled={isLoading}>
          {isLoading && (
            <CircularProgress
              size={20}
              sx={{ marginRight: "8px", color: "white" }}
            />
          )}
          Clear Location
        </DangerButton>
      </StyledDialogActions>
    </Dialog>
  );
};
